import { Button, Flex, Form, Popup, Spacing, Text, TextField } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { useEmailChangeViaSupportPopup } from './EmailChangeViaSupportPopup.hooks';
import { messages } from './EmailChangeViaSupportPopup.messages';
import { EmailChangeViaSupportPopupProps } from './EmailChangeViaSupportPopup.types';

export const EmailChangeViaSupportPopup = memo<EmailChangeViaSupportPopupProps>((props) => {
    const { open, onClose } = props;

    const { form, formSubmit } = useEmailChangeViaSupportPopup(props);

    // TODO: Implement after BE is ready
    const temporaryProgress = false;
    const temporaryDisabled = false;

    return (
        <Popup open={open} onClose={onClose} size='xsmall'>
            <Form form={form} onSubmit={formSubmit}>
                <Popup.Header
                    title={messages.title}
                    actionsSize='small'
                    actions={
                        <Button
                            type='submit'
                            variant='text'
                            color='blue100'
                            size='small'
                            progress={temporaryProgress}
                            disabled={temporaryDisabled}
                        >
                            {messages.buttonSend}
                        </Button>
                    }
                />

                <Popup.Body>
                    <Spacing height={4} />

                    <Flex direction='column' spacing='24'>
                        <Flex direction='column' spacing='8'>
                            <Text font='body' fontSize='small' fontWeight='medium'>
                                {messages.subtitle}
                            </Text>

                            <Text font='body' fontSize='small' fontWeight='regular'>
                                {messages.description}
                            </Text>
                        </Flex>

                        <Flex direction='column' spacing='16'>
                            <TextField
                                name='email'
                                type='email'
                                label={messages.fieldEmailLabel}
                                placeholder={messages.fieldEmailPlaceholder}
                                size='small'
                                required
                            />
                        </Flex>
                    </Flex>
                </Popup.Body>
            </Form>
        </Popup>
    );
});

EmailChangeViaSupportPopup.displayName = 'EmailChangeViaSupportPopup';
